export default __webpack_public_path__ + "static/media/foto_01.851120d9.jpg";